import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

declare var gapi: any;
@Component({
    selector: 'app-create-devis-open-id',
    templateUrl: './create-devis-open-id.component.html',
    styleUrls: ['./create-devis-open-id.component.css'],
    standalone: false
})
export class CreateDevisOpenIdComponent implements OnInit, OnDestroy {
  client: any = { id: 0 };
  detailDevis: any = { id: 0 };
  isEmpty: Boolean = true;
  showFicheclt: Boolean = false;
  userGoogle: any;
  gapiSetup: any;
  authInstance;
  errorGoogle;
  parametersObservable;
  error = '';
  codeExterne = ''
  @ViewChild('msg', {static: true}) msg;
  @ViewChild('document', {static: true}) document;
  constructor(protected common: CommonService, private route: ActivatedRoute, private modalService: BsModalService) {
  }


  async ngOnInit() {
    console.log('test123')
    const soc = this.common.local.getObject('paramSociete') || {};
    if (soc['bdHolding'] && this.common.isProspectHolding) {
      this.common.local.setObject('nomBDHolding', { 'nomBDHolding': soc['bdHolding'] })
    }
    // this.common.local.setObject('userGoogle', this.userGoogle);
    this.common.docTemplate = this.document;
    this.parametersObservable = this.route.paramMap.subscribe(params => {
      const param = params['params'];
      console.log(param);
      this.codeExterne = param.codeExterneAffaire;
      this.getclientByCodeClient(param.codeExterneClient).then(client => {
        if (client && (client.id <= 0 || !client.id)) {
          this.error = 'Le client fourni en paramètre n\'existe pas encore';
          this.common.openModal(this.modalService, this.msg);
        }
        if (client && client.id > 0 && !client.prospectHolding) {
          this.getDetailClient(client.id).then(elt => {
            if (elt && elt['id']) {
              this.getDevisByCodeExterneAffaire(param.codeExterneAffaire).then(devis => {
                console.log(devis, this.detailDevis)
                if (devis && devis.id) {
                  this.detailDevis = devis;
                } else {
                  this.detailDevis = { id: 0 };
                }
                this.isEmpty = false;
              });
            } else {
              this.error = 'Le client fourni en paramètre n\'existe pas encore';
              this.common.openModal(this.modalService, this.msg);
            }
          })
        } else if (client && client.id > 0 && client.prospectHolding) {
          this.changeProspectToClient(client).then(elt => {
            if (elt && elt['id']) {
              this.getDevisByCodeExterneAffaire(param.codeExterneAffaire).then(devis => {
                console.log(devis, this.detailDevis)
                if (devis && devis.id) {
                  this.detailDevis = devis;
                } else {
                  this.detailDevis = { id: 0 };
                }
                this.isEmpty = false;
              });
            } else {
              this.error = 'Le client fourni en paramètre n\'existe pas encore';
              this.common.openModal(this.modalService, this.msg);
            }
          });
        }
      });
    });
  }

  // updateListContact() {
  //   this.client['nomclass'] = 'Client';
  //   const param = {
  //     'OPERATION': {
  //       'typeParam': 'int',
  //       'valeur': 7
  //     },
  //     'CLIENT': this.client,
  //     'HOLDING_SERVLET': 'DBGestionProspect',
  //     'HOLDING_MODULE': 'Recylog',
  //     'HOLDING_TYPE': 'map',
  //     'HOLDING_COMPRESSION': 'false',
  //     'CRITERE_CHANTIER': ''
  //   };
  //   return this.common.DBGestionAppelHolding(param).then(datas => {
  //     if (datas.data) {
  //       this.client['listChantier'] = datas.data['listChantier'] || this.client['listChantier'] || [];

  //       this.client['listChantier'].forEach(elt => {
  //         if (elt.dateFin) {
  //           elt.dateFin = moment(elt.dateFin, 'YYYY-MM-DD').format('DD/MM/YYYY');
  //         }
  //       })
  //       this.client['listContact'] = datas.data['listContact'] || this.client['listContact'] || [];
  //     }
  //   });
  // }

  changeProspectToClient(prospect) {
    prospect.nomclass = 'Prospect';
    prospect.nom = prospect.nomClient || '';
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 15
        },
        'PROSPECT': prospect,
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.client = datas.data;
        return datas.data;
      }
    });
  }

  ngOnDestroy() {
    if (this.parametersObservable != null) {
      this.parametersObservable.unsubscribe();
    }
  }


  async signOut() {
    const ctrl = this;
    ctrl.userGoogle = false;
    ctrl.common.local.remove('userGoogle');
    this.isEmpty = true;
    const auth2 = gapi.auth2.getAuthInstance();
    auth2.signOut().then(function () {
    });

  }

  getclientByCodeClient(id) {
    const param = {
      'servlet': 'DBGestionMobiCRM',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CODE_EXTERNE': '' + id,
      }
    };
    if (id) {
      return this.common.post('', { param: param }).then(datas => {
        if (datas.data) {
          console.log(datas.data)
          return datas.data || {};
        }
      });
    } else {
      return Promise.resolve();
    }
  }

  getDevisByCodeExterneAffaire(id) {
    this.codeExterne = id;
    console.log(this.codeExterne);
    const param = {
      'servlet': 'DBGestionMobiCRM',
      'module': 'Ecocrm',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CODE_AFFAIRE': '' + id,
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        console.log(datas.data)
        return datas.data || {};
      }
    });
  }

  getDetailClient(id) {
    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };
    if (id) {
      return this.common.post('', { param: param }).then(datas => {
        if (datas.data) {
          this.client = datas.data[0];
          return datas.data[0];
        }
      });
    } else {
      return Promise.resolve();
    }
  }

  closeAndOpen() {
    this.isEmpty = true;
    const ctrl = this;
    setTimeout(function () {
      ctrl.isEmpty = false;
    }, 200);
  }

  showFiche() {
    this.showFicheclt = !this.showFicheclt;
  }

}
